import { useTranslation } from "react-i18next";
import StatsCard from "./StatsCard";
import LoadingCard from "./LoadingCard";

import { ExecutionStatRecord } from "@dashboard-v3/api";

interface Props {
  loading: boolean;
  currentStats: ExecutionStatRecord[];
  previousStats: ExecutionStatRecord[];
}

export default function ProcessedEmailsCard(props: Props) {
  const { loading, previousStats, currentStats } = props;
  const { t } = useTranslation("usageReports");

  if (loading) return <LoadingCard />;

  const previous = previousStats.reduce(toExecutionTotal, 0);
  const current = currentStats.reduce(toExecutionTotal, 0);

  return (
    <StatsCard
      label={t("processedEmails.title")}
      value={current.toLocaleString()}
      previousAmount={previous}
      currentAmount={current}
    />
  );
}

const toExecutionTotal = (acc: number, executions: ExecutionStatRecord) => {
  return acc + executions.total;
};
